import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../../utils/contants";

export const TaskBodyStyled = styled.div`
  padding: 5px 45px 5px 36px;
  .role {
    display: flex;
    gap: 15px;
    align-items: center;

    p {
      font-size: 14px !important;
    }
  }

  .top-row {
    display: flex;
    justify-content: space-between;
    .headings {
      display: flex;
      width: 238px;
      justify-content: space-around;
    }
  }
  .task-row {
    padding: 10px 0px;
    display: grid;
    grid-template-columns: 1.5fr 0.5fr;
    justify-content: space-between;
  }

  .row-border {
    border-bottom: 1px solid ${COLOUR_CONSTANT.theme.light};
    display: grid;
    grid-template-columns: 1.5fr 0.5fr;
  }
  .actions {
    display: flex;
    column-gap: 16px;

    .pointer-none {
      pointer-events: none;
    }
  }

  /* Custom styles for rectangular switch */
  .MuiSwitch-root {
    width: 42px;
    height: 24px;
    display: flex;
    border: 1px solid #080425;
    border-radius: 4px;
  }

  .not-enabled-switch {
    border: 1px solid #dedafb;
  }
  .MuiSwitch-switchBase {
    padding: 2px;
    transform: translateX(18px); /* Default position on the right */
    &.Mui-checked {
      transform: translateX(2px); /* Move to the left when enabled */
      color: #fff;
      + .MuiSwitch-track {
        background-color: white; /* Primary color for enabled state */
        opacity: 1;
      }

      /* Ensure the thumb color changes when checked */
      .MuiSwitch-thumb {
        background-color: #080425 !important;
      }
    }
  }

  .MuiSwitch-thumb {
    width: 20px;
    height: 20px;
    border-radius: 4px; /* Make thumb rectangular */
    background-color: ${COLOUR_CONSTANT.theme
      .lightPink}; /* Default thumb color */
    transition: background-color 0.3s;
  }

  .MuiSwitch-track {
    border-radius: 4px; /* Make track rectangular */
    background-color: white; /* Default track background color */
    /* border: 1px solid ${COLOUR_CONSTANT.theme.lightPink}; */
    opacity: 1;
    transition: background-color 0.5s;
  }
`;
